import React from "react";
import { TraitSale } from "types";

export type TraitSalesContextValue = {
  traitSales: TraitSale[];
  traitSalesByTokenId: Record<number, TraitSale>;
  fetchTraitSales: () => void;
  isLoading: boolean;
};

const TraitSalesContext = React.createContext<TraitSalesContextValue>({
  traitSales: [],
  traitSalesByTokenId: {},
  fetchTraitSales: () => {},
  isLoading: false,
});

export default TraitSalesContext;
